// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__21C-O","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3scxE"};